import { IStyles } from '@interfaces/styles';
import { colors } from '@constants/colors';

export const useStyles = (): IStyles => {
  return {
    emptyPlaceholderTitle: {
      fontWeight: 600,
      fontSize: 20,
      textAlign: ['left', 'left'],
      mt: '32px',
      mb: '16px',
      lineHeight: 1.5,
    },
    emptyPlaceholderBody: {
      fontWeight: 400,
      fontSize: 15,
      textAlign: ['left', 'left'],
      lineHeight: 1.5,
    },
    version: {
      position: 'fixed',
      bottom: 16,
      left: 16,
      fontSize: 10,
      paddingX: 1,
      paddingY: 0.5,
      borderRadius: 2,
      background: 'rgba(184, 184, 184, 0.1)',
      fill: colors.grey_300,
    },
  };
};
